import React from "react";
import { Link } from "react-router-dom";
import {
  Alert,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  ListGroup,
  ListGroupItem,
  Row,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

const NS_HOSTS = ["ns1.dns.brenvio.com.br", "ns2.dns.brenvio.com.br"];

/**
 * Orientação ops: DNS por NS para clientes Br Domínio.
 * Só Super Admin — proibido publicar no help center.
 */
const SuperAdminDnsNsGuide = () => {
  const { t } = useTranslation();
  document.title = t("sa.dnsNs.documentTitle");

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title={t("sa.dnsNs.title")}
          pageTitle={t("sa.menu.ops")}
        />

        <Alert color="warning" className="mb-3">
          {t("sa.dnsNs.notHelp")}
        </Alert>

        <Row>
          <Col lg={8}>
            <Card>
              <CardHeader>
                <h5 className="card-title mb-0">{t("sa.dnsNs.title")}</h5>
              </CardHeader>
              <CardBody>
                <p>{t("sa.dnsNs.intro")}</p>
                <ListGroup flush className="mb-3">
                  <ListGroupItem>{t("sa.dnsNs.step1")}</ListGroupItem>
                  <ListGroupItem>{t("sa.dnsNs.step2")}</ListGroupItem>
                  <ListGroupItem>{t("sa.dnsNs.step3")}</ListGroupItem>
                  <ListGroupItem>{t("sa.dnsNs.step4")}</ListGroupItem>
                  <ListGroupItem>{t("sa.dnsNs.step5")}</ListGroupItem>
                </ListGroup>
                <h6 className="mb-2">{t("sa.dnsNs.nameservers")}</h6>
                <ul className="mb-3">
                  {NS_HOSTS.map((h) => (
                    <li key={h}>
                      <code>{h}</code>
                    </li>
                  ))}
                </ul>
                <Link to="/super-admin/tenants" className="btn btn-soft-primary btn-sm">
                  {t("sa.menu.tenants")}
                </Link>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SuperAdminDnsNsGuide;
